import { Logout } from "@mui/icons-material";
import { Box, IconButton } from "@mui/material";
import React from "react";
import { Link } from "react-router-dom";
import { Context } from "../../App";

export default function Header() {
    const { deconnect } = React.useContext(Context);
    return (
        <header style={{ padding: "16px", borderBottom: "1px solid #ddd", marginBottom: "24px", display: "flex", alignItems: "center" }}>
            <Link to="/"><h1 style={{ margin: 0, fontSize: "1.5rem" }}>EVS Pub CMS</h1></Link>
            <Box sx={{flex:1}}/>
            <IconButton onClick={deconnect}><Logout /></IconButton>
        </header>
    );
}